import { Component, Input } from '@angular/core';

import { Gear } from '../../shared/models/gear.model';

@Component({
  host: {
    'test-id': 'gear-info',
  },
  selector: 'gear-info',
  styleUrls: ['./gear-info.component.scss'],
  templateUrl: './gear-info.component.html',
})
export class GearInfoComponent {
  @Input() gear: Gear
}
